'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'email';
const EMAIL_ERROR = 'email';
/**
 * NOTE: Opting to use a custom validation regex according to Okta's specs.
 * Refer to: [https://help.okta.com/en-us/content/topics/directory/reference_directories.htm].
 *
 * Yup docs recommend overriding email to preferred method:
 * [https://www.npmjs.com/package/yup#stringemailmessage-string--function-schema].
 */ y__namespace.addMethod(y__namespace.StringSchema, name, function(message) {
    return this.test({
        name,
        message: ({ path })=>{
            return {
                key: message ?? EMAIL_ERROR,
                path
            };
        },
        test: (value)=>{
            if (!value) {
                return true;
            }
            return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/.test(value);
        }
    });
});

exports.EMAIL_ERROR = EMAIL_ERROR;
//# sourceMappingURL=email.js.map
